import axios from "axios";
import Config from "../config/Config";
import { AppContextInterface } from "../contexts/AppContext";

export const API = axios.create({
	baseURL: Config.BASE_URL_API
});

// export default API;
export const configAPIHeaders = (appContext: AppContextInterface, token: string, userID: string) => {
	API.defaults.headers.common['authorization'] = token;
	API.defaults.headers.common['user_id'] = userID;
	API.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
	API.defaults.headers.common['Access-Control-Allow-Headers'] = 'Content-Type';
	API.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
	API.defaults.headers.common['Accept'] = 'application/json';
}

// API.interceptors.response.use(response => response, error => {
//   const { status, statusText, data } = error.response || {};

//   const event = {
//     message: `Error occurred: ${status} - ${statusText}`,
//     error: data.message || 'Unknown error',
//     requestId: 'REQUEST_ID_HERE',
//     namespace: 'business-web',
//   };

//   sendEventToBaselime(event);

//   return Promise.reject(error);
// });

// // Função para enviar o evento para o Baselime
// function sendEventToBaselime(event) {
//   axios.post('https://events.baselime.io/v1/logs', event, {
//     headers: {
//       'x-api-key': 'f254e0fc706e198b5985b7fea77085409c101595',
//       'Content-Type': 'application/json',
//       'x-service': 'business-web', 
//     },
//   })
//   .then(response => {
//     console.log('Evento enviado para Baselime:', response.data);
//   })
//   .catch(error => {
//     console.error('Erro ao enviar evento para Baselime:', error);
//   });
// }